import { Dialog } from "primereact/dialog";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { ITimesheet } from "../../models/Timesheet";
import { JVChips } from "../../shared/JVChips";

const schema = yup.object({
    emailTo: yup.array().of(yup.string().email("Invalid Email ID")).min(1, "This field is required"),
    emailCC: yup.array().of(yup.string().email("Invalid Email ID")).nullable(),
    subject: yup.string().required("Email Subject is required")
});

interface IProps {
    singleData: ITimesheet
    open: boolean,
    hideDialog: () => void,
    toast: any
}

interface IMail {
    emailTo: string[],
    emailCC: string[],
    subject: string,
    emailBody: string
}

export const Mail = ({ singleData, open, hideDialog, toast }: IProps) => {
    const [loading, setLoading] = useState(false);
    const [body, setBody] = useState("");

    const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm<IMail>({
        resolver: yupResolver(schema),
        defaultValues: {
            emailTo: [],
            emailCC: [],
            subject: '',
            emailBody: ''
        },
        shouldFocusError: false
    });

    const sendMail = async (fbody: IMail) => {
        setLoading(true);
        fbody.emailBody = body;
        // console.log(fbody);
        const response = await Fetch("Timesheet/mail", "POST", fbody, null, toast);
        if (response) {
            onHide();
            toast.current.show({ severity: 'success', detail: "Mail Distributed Successfully.", life: 3000 });
        }
        setLoading(false);
    }

    function onSubmit(data: IMail) {
        if (body.length < 1) toast.current.show({ severity: 'error', detail: "Mail Body is Required.", life: 3000 });
        else sendMail(data);
    }

    const onHide = () => {
        hideDialog(); reset(); setBody("");
    }

    const header = () => {
        return <span>{singleData.consultant_Name}</span>
    }

    return (
        <Dialog visible={open} style={{ width: '80vw' }} header={header} className="p-fluid" onHide={onHide} draggable={false}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVChips column={2} label="To" control={control} name="emailTo" error={errors.emailTo?.message ? errors.emailTo?.message : errors.emailTo && errors.emailTo[0]?.message} separator="," />
                <JVChips column={2} label="CC" control={control} name="emailCC" error={errors.emailCC && errors.emailCC[0]?.message} separator="," />
                <JVInput column={1} required label="Subject" control={control} name="subject" error={errors.subject?.message} />
                <div className="col-12 md:col-12 md:col-6 mb-3">
                    <label>Body<span style={{ color: 'red' }}>*</span></label>
                    <CKEditor editor={ClassicEditor} data={body} onChange={(event, editor) => { setBody(editor.getData()); }} />
                </div>
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6  h-2rem" label="SEND" type="submit" loading={loading}></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}